(function(){
	'strict';

	const $ = jQuery;

	Vue.component('projects-to-be-reported', {
		template: '#v-projects-to-be-reported',
		props: [],
		data() {
			return {
				jobIds: [],
				projectIds: [],
				isUpdating: false,
				projectsToBeReported: [],
			};
		},
		methods: {
			resetData() {
				this.jobIds = [];
			},
			onShowTab() {
				const _this = this;
				this.isUpdating = true;
				window.ajaxCall({
					data: {
						action: 'get_projectsToBeReported',
					},
					onSuccess: function(response){
						_this.projectsToBeReported = response.data.projectsToBeReported;
						_this.isUpdating = false;
					},
				});
			},
			refreshSelectedProjects() {
				const projectIds = [];
				const jobIds = [];
				$( 'div.projects-to-be-reported input.ready-to-be-reported:checked', this.$el ).each( function() {
					if ( $( this ).data( 'project-id' ) )
						projectIds.push( $( this ).data( 'project-id' ) );
					else
						jobIds.push( $( this ).data( 'job-id' ) );
				} );
				this.projectIds = projectIds;
				this.jobIds = jobIds;
			},
			updateSelectedProjects() {
				const _this = this;
				this.isUpdating = true;
				window.ajaxCall({
					data: {
						action: 'set_projects_as_reported',
						jobIds: this.jobIds,
						projectIds: this.projectIds,
					},
					onSuccess: function(response){
						$( '.scroll-box input.ready-to-be-reported', this.$el ).prop( 'checked', false );
						_this.projectsToBeReported = response.data.projectsToBeReported;
						_this.isUpdating = false;
					},
				});
			}
		},
        computed: {
			hasSelectedProjects() {
				return this.jobIds.length > 0 || this.projectIds.length > 0;
			},
			projectCount() {
				return this.projectsToBeReported.length;
			},
		},
	});
})();
